import { useMediaQuery } from "@mui/material";

/** Same query as the phone layout of SWEB-999999. TODO PDI-458: use that one once merged */
export const PHONE_VIEWPORT_QUERY =
  "(max-width: 599.95px), (pointer: coarse) and (hover: none) and (orientation: landscape) and (max-height: 599.95px)";

/** @returns Whether the viewport needs phone-sized controls. */
export function usePhoneViewport(): boolean {
  return useMediaQuery(PHONE_VIEWPORT_QUERY);
}
